import { useCallback, useEffect, useMemo, useState } from 'react';
import { ADD_BINDERS } from '../utils/constants';
import CreateBinderDialog from '../components/CreateBinderDialog';
import QuickAdd from '../components/QuickAdd';
import { selectCurrentMember } from '../store/authSlice';
import { useSelector } from 'react-redux';
import useBinders from '../hooks/api/useBinders';
import PageHeader from '../components/PageHeader';
import PageLoading from '../components/PageLoading';
import Alert from '../components/Alert';
import List from '../components/List';
import NoDataMessage from '../components/NoDataMessage';
import BinderRow from '../components/BinderRow';
import SearchField from '../components/inputs/SearchField';
import useDialog from '../hooks/useDialog';
import FadeIn from '../components/FadeIn';

export default function BindersIndexPage() {
  useEffect(() => {
    document.title = 'Folders';
  });

  const [isOpen, showDialog, hideDialog] = useDialog();
  const [query, setQuery] = useState('');
  // Non-null: kept as before, this throws if the membership hasn't loaded.
  const currentMember = useSelector(selectCurrentMember)!;

  const { data: binders, isLoading, isError, isSuccess } = useBinders();

  const searchBinders = useCallback(() => {
    if (query.length > 1) {
      return binders?.filter(song =>
        song.name.toLowerCase().includes(query.toLowerCase())
      );
    } else {
      return binders;
    }
  }, [query, binders]);

  const queriedBinders = useMemo(() => searchBinders(), [searchBinders]);

  return (
    <div className="mb-10">
      <PageHeader title="Folders" />
      {isLoading && <PageLoading />}
      {isError && (
        <Alert color="red">There was an issue retrieving your folders.</Alert>
      )}

      {isSuccess && (
        <>
          <FadeIn>
            <div className="mb-2">{binders.length} total</div>
            <SearchField
              placeholder="Search your folders"
              value={query}
              onChange={setQuery}
              className="mb-4"
            />
          </FadeIn>
          <FadeIn className="delay-100">
            <List
              data={queriedBinders}
              ListEmpty={<NoDataMessage type={'folders'} />}
              className="delay-100"
              renderItem={binder => (
                <BinderRow binder={binder} key={binder.id} />
              )}
            />
          </FadeIn>
        </>
      )}

      {currentMember.can(ADD_BINDERS) && (
        <>
          <CreateBinderDialog open={isOpen} onCloseDialog={hideDialog} />
          <QuickAdd onAdd={showDialog} label="New folder" />
        </>
      )}
    </div>
  );
}
